var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconOnEarDetection = function SvgIconOnEarDetection(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 25,
    fill: "currentColor"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M7.08 13.96a1.5 1.5 0 0 0-1.837-1.061l-1.056.283a3 3 0 0 0-2.121 3.674l.748 2.79a2 2 0 0 0 2.45 1.415l1.52-.407c.518-.14.958-.48 1.225-.946s.338-1.02.199-1.539zM5.5 13.865a.5.5 0 0 1 .613.353l1.128 4.21c.07.265.034.547-.1.783a1.01 1.01 0 0 1-.618.477l-1.52.407a1 1 0 0 1-1.224-.707l-.748-2.79a2 2 0 0 1 1.414-2.45zM16.92 13.96a1.5 1.5 0 0 1 1.837-1.061l1.056.283a3 3 0 0 1 2.121 3.674l-.747 2.79a2 2 0 0 1-2.45 1.415l-1.52-.407a2.01 2.01 0 0 1-1.226-.946 2.04 2.04 0 0 1-.198-1.539zm1.579-.095a.5.5 0 0 0-.613.353l-1.128 4.21c-.07.265-.034.547.101.783s.357.407.617.477l1.52.407a1 1 0 0 0 1.225-.707l.747-2.79a2 2 0 0 0-1.414-2.45z",
    clipRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M2.899 12.706a9.1 9.1 0 1 1 18.2 0v1.4a.5.5 0 1 1-1 0v-1.4a8.1 8.1 0 1 0-16.2 0v1.4a.5.5 0 0 1-1 0z",
    clipRule: "evenodd"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M13.628 11.486a.5.5 0 0 1 .052.705l-2.255 2.613-1.083-1.106a.5.5 0 1 1 .714-.7l.322.33 1.545-1.79a.5.5 0 0 1 .705-.053",
    clipRule: "evenodd"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M12 16.054a3.087 3.087 0 1 0 0-6.174 3.087 3.087 0 0 0 0 6.174m0 .913a4 4 0 1 0 0-8 4 4 0 0 0 0 8",
    clipRule: "evenodd"
  })));
};
export default SvgIconOnEarDetection;